// import { useCallback, memo } from "react";
// import styles from "./textLinkRenderer.css";
// import React from "react";
// import { Button} from "antd";
// import { useNavigate } from "react-router-dom";
// const TextLinkRenderer1 = (params) => {
//   // const { handleClick} = params;
//   const { handleClick} = params;
//   // const navigate = useNavigate();
//   console.log(handleClick,"handleClick")
//   // console.log(pdfLink,"pdfLink")
//   const onLinkClick = useCallback(
//     (e) => {
//       e.stopPropagation();
//       handleClick(params);
//     },
//     [handleClick, params]
//   );
//   return (
//     <>
//     <div onClick={onLinkClick}>
//       <Button className={`link-primary text-truncate ${styles.textLink}`}
//       style={{height:"28px", marginTop:"5px"}}
//       >
//         Invoice
//       </Button>
//     </div>
//     </>
//   );
// };
// export default memo(TextLinkRenderer1);




import { useCallback, memo } from "react";
import styles from "./textLinkRenderer.css";
import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

const TextLinkRenderer1 = (props) => {
  const { handleClick, api, value, pdfFieldName } = props;
  console.log(props,"props in text")

  const onLinkClick = useCallback(
    (e) => {
      e.stopPropagation();
      // Pass api, value, and pdfFieldName to the handleClick function
      handleClick({ api, value, pdfFieldName });
    },
    [handleClick, api, value, pdfFieldName]
  );

  return (
    <div onClick={onLinkClick}>
      <Button className={`link-primary text-truncate ${styles.textLink}`} style={{ height: "28px", marginTop: "5px" }}>
        Invoice
      </Button>
    </div>
  );
};


export default memo(TextLinkRenderer1);


